<template>
  <section>
    <FullModal
      :headerInfo="headerInfo"
      @onClose="onCloseCrawler"
      :hasIcon="true"
    >
      <template #content>
        <div id="legend">
          <div
            class="container mx-auto my-8 flex flex-col gap-5 w-full md:w-6/12"
          >
            <h4>
              {{
                $t("labels.generic", {
                  pt: "Buscar por vídeos",
                  en: "Search for videos",
                })
              }}
            </h4>
            <div id="filters" class="grid grid-cols-12 items-center gap-3">
              <div class="col-span-12">
                <span class="p-input-icon-right w-full">
                  <i
                    v-if="!search.submited"
                    class="pi pi-search cursor-pointer"
                    @click="onSearch()"
                  />
                  <i
                    v-else
                    class="pi pi-times cursor-pointer"
                    @click="onSearch('clear')"
                  ></i>
                  <InputText
                    v-model="search.value"
                    :placeholder="$t('crawler.placeholder')"
                    class="w-full"
                    @keyup.enter="onSearch()"
                  />
                </span>
              </div>
              <div v-if="search.submited" class="col-span-12">
                <p
                  v-html="
                    $t('labels.generic', {
                      pt: `Você pesquisou por “<b>${search.submited}</b>”, esses foram os resultados encontrados:`,
                      en: `You searched for “<b>${search.submited}</b>”, these were the results found:`,
                    })
                  "
                ></p>
              </div>
            </div>

            <Loader v-if="loading" :loader="loading" loaderSize="h-96" />

            <div v-else id="content">
              <div class="my-5" v-if="data.length !== 0">
                <Card :data="data" />
              </div>

              <EmptyData
                v-else
                :data="!data || data.length == 0"
                :title="emptyState.title"
                :label="emptyState.description"
                :image="emptyState.image"
                imgSize="h-52 my-10"
                msgSize="md:w-8/12"
              />
            </div>
          </div>
        </div>
      </template>
    </FullModal>
  </section>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { useVideoStore } from "@/store/video";
import { getItemStorage } from "@/utils/save-storage.util";
import { defineAsyncComponent, defineComponent } from "vue";
import { CrawlerService } from "./crawler.service";
import { GenericsUtils } from "@/utils/generics.util";

const Card = defineAsyncComponent(() => import("./Card/card.vue"));

export default defineComponent({
  name: "crawler",
  emits: ["onClose"],
  props: {
    keyword: {
      type: String,
    },
    transcriptId: {
      type: String,
      default: "",
    },
  },
  components: { Card },
  computed: {
    service(): CrawlerService {
      return new CrawlerService();
    },
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
  },
  unmounted() {
    useVideoStore.setAttention(false);
  },
  data() {
    return {
      courseName: getItemStorage("courseName") as string,
      emptyState: new Object({
        image: "empty-crawler.svg",
        title: this.$t("crawler.empty.title"),
        description: this.$t("crawler.empty.description"),
      }) as any,
      search: new Object({ submited: "", value: this.keyword }) as any,
      loading: true as boolean,
      data: [] as Array<any>,
      headerInfo: {
        title: this.$t("labels.generic", {
          pt: "Buscar vídeos",
          en: "Search for videos",
        }),
        subtitle: this.$t("labels.generic", {
          pt: "Pesquise palavra-chaves nos vídeos dos cursos.",
          en: "Search keywords in course videos.",
        }),
        icon: "crawler-icon.svg",
      } as any,
    };
  },
  mounted() {
    if (this.courseName) this.getCrawler(this.transcriptId);
    else this.$router.go(-1);
    useVideoStore.setAttention(false);
    this.getCrawler(this.transcriptId);
    if (this.courseName) this.getCrawler(this.transcriptId);
    else this.$router.go(-1);
    useVideoStore.setAttention(false);
  },
  methods: {
    onSearch(event?: "clear"): void {
      if (!event) {
        this.getCrawler();
      } else {
        this.search["value"] = "";
        this.getCrawler();
      }
    },
    getCrawler(transcriptId: string = ""): void {
      const params = new QueryParams();
      params.page = undefined as any;
      params.size = undefined as any;
      params.word = this.search["value"];
      params.transcriptId = transcriptId ? transcriptId : undefined;
      this.loading = true;
      this.search["submited"] = params.word;

      this.service
        .getIndexedVideos(params)
        .then((response) => {
          response.contents.forEach((item) => {
            item.url = this.generics.getSecureUrl(item.url);
          });
          this.data = response.contents;
          window.scrollTo(0, 0);
        })
        .finally(() => (this.loading = false));
    },
    onCloseCrawler(): void {
      this.$emit("onClose");
    },
  },
});
</script>
